import { Provider as JotaiProvider } from "jotai";

import { PaymentOptionProvider } from "checkout-experience/components/payment-method/payment-option-provider";
import {
  CheckoutExperience,
  CheckoutExperienceProps,
} from "checkout-experience/layouts/checkout-experience";
import { ChexContextWrapper } from "checkout-experience/providers/chex-context-wrapper";
import { ExperienceType } from "checkout-query-client/api/types";
import { CheckoutSession } from "checkout-query-client/hooks/use-checkout-session";

interface Props extends CheckoutExperienceProps {
  experienceType?: ExperienceType;
  checkoutSession: CheckoutSession | undefined;
  controlledSubmit?: boolean;
  isCheckoutSessionLoading?: boolean;
  checkoutSessionToken?: string;
  apiHost?: string;
  version?: string;
  googlePayEnv?: string;
  isDemo?: boolean;
  pazeSDK?: string;
  deviceFingerprintSDK?: string;
  target: string;
  iframePayDomain?: string;
}

export const CheckoutExperienceWrapper = ({
  merchantSettings,
  experienceType,
  checkoutSession,
  isCheckoutSessionLoading,
  checkoutSessionToken,
  apiHost,
  version,
  googlePayEnv,
  controlledSubmit,
  isDemo,
  pazeSDK,
  deviceFingerprintSDK,
  target,
  iframePayDomain,
  ...rest
}: Props) => {
  return (
    <JotaiProvider>
      <ChexContextWrapper
        value={{
          merchantSettings,
          experienceType,
          checkoutSession,
          isCheckoutSessionLoading,
          checkoutSessionToken,
          apiHost,
          version,
          googlePayEnv,
          controlledSubmit,
          isDemo,
          pazeSDK,
          deviceFingerprintSDK,
          target,
          iframePayDomain,
        }}
      >
        <PaymentOptionProvider>
          <CheckoutExperience {...rest} />
        </PaymentOptionProvider>
      </ChexContextWrapper>
    </JotaiProvider>
  );
};
